import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogBaseComponent } from '../../common/dialog/dialog-base/dialog-base.component';
import { DialogService } from 'src/app/services/UI/dialog.service';

@Component({
  selector: 'app-user-profile-main',
  templateUrl: './user-profile-main.component.html',
  styleUrls: ['./user-profile-main.component.scss']
})
export class UserProfileMainComponent extends DialogBaseComponent implements OnInit  {

  constructor(dialogService: DialogService,private ref1: ChangeDetectorRef) { 
    super(dialogService, ref1);
  }

   ngOnInit(): void {
    this.getViewMode();
  }

  getViewMode(): Number{
    return this.data.viewMode;
  }

  changeViewMode(mode) {   
    this.data.viewMode = mode;
  }
}
